import BaseComponent from '../base/baseComponent';
import customEventBus from '../libs/eventBus';
import micromodalInstance from '../libs/micromodalInstance';
import analyticsUtils from '../utilities/analyticsUtils';
export default class AddToCart extends BaseComponent {
    get SELECTORS() {
        return {
            inputQuantity: '.quantity-selector-container .js-input-quantity',
            incrementBtn: '.quantity-selector-container .js-add-quantity',
            decrementBtn: '.quantity-selector-container .js-remove-quantity',
            quantitySelectorContainer: '.quantity-selector-container',
            removeCta: '.btn-removetocart',
        };
    }
    get CLASSES() {
        return {
            loading: 'loading',
            disabled: 'disabled',
            dNone: 'd-none',
        };
    }
    constructor(element) {
        super(element);
        // customEventBus.on('modal:show', (data: any) => {
        //   if (data.modalId === 'modal-feedback-error' || data.modalId === 'modal-feedback-success') {
        //     const modalElement = document.querySelector(`#${data.modalId}`);
        //     if (modalElement) {
        //      if (!modalElement.getAttribute('data-error-customer'))
        //       setTimeout(() => {
        //         micromodalInstance.forceClose(data.modalId);
        //       }, 3500);
        //     }
        //   }
        // });
        this.handleClick();
    }
    handleClick() {
        this._el.addEventListener('click', (e) => {
            this.addToCartFlow();
        });
    }
    updateMessageInModal(modalId, message) {
        const modal = document.querySelector(`#${modalId}`);
        if (modal) {
            let messageHtml = modal.querySelector('.message');
            messageHtml.innerHTML = message;
        }
    }
    updateCta(isOneQuantityConstraint, pliUUID) {
        // if (isOneQuantityConstraint) {
        //   let removeBtn = this._el.closest('.addtocart-actions').querySelector(this.SELECTORS.removeCta);
        //   this._el.classList.add(this.CLASSES.dNone);
        //   if (removeBtn) {
        //     removeBtn.classList.remove(this.CLASSES.dNone);
        //     removeBtn.setAttribute('data-option-uuid', pliUUID);
        //   }
        // } else {
        this._el.setAttribute('disabled', 'true');
        this._el.classList.add(this.CLASSES.disabled);
        let maxQtyLabel = this._el.dataset.labelMaxqty;
        this._el.innerHTML = maxQtyLabel;
        // }
    }
    async addToCartFlow() {
        try {
            const inputQuantity = document.querySelector(this.SELECTORS.inputQuantity);
            const qty = inputQuantity ? inputQuantity.value : '1';
            const data = await this.addToCart(this._options.pid, qty, this._options.excludedCustomerType);
            const { error, message, deltaAvailableInventory, isOneQuantityConstraint, pliUUID, errorCustomerType } = data;
            if (error) {
                this._el.classList.remove(this.CLASSES.loading);
                this.updateMessageInModal('modal-feedback-error', message);
                let modalError = document.querySelector('#modal-feedback-error');
                if (errorCustomerType) {
                    if (modalError) {
                        modalError.setAttribute('data-error-customer', 'true');
                    }
                }
                else {
                    if (modalError) {
                        modalError.removeAttribute('data-error-customer');
                    }
                }
                micromodalInstance.forceShow('modal-feedback-error');
            }
            else {
                if (deltaAvailableInventory !== null) {
                    if (qty >= deltaAvailableInventory) {
                        let incrementBtn = document.querySelector(this.SELECTORS.incrementBtn);
                        let decrementBtn = document.querySelector(this.SELECTORS.decrementBtn);
                        if (deltaAvailableInventory === 0) {
                            this.updateCta(isOneQuantityConstraint, pliUUID);
                            let quantitySelectorContainer = document.querySelector(this.SELECTORS.quantitySelectorContainer);
                            if (quantitySelectorContainer) {
                                quantitySelectorContainer.classList.add('d-none');
                            }
                        }
                        else if (deltaAvailableInventory === 1) {
                            if (incrementBtn) {
                                incrementBtn.setAttribute('disabled', 'true');
                                incrementBtn.classList.add(this.CLASSES.disabled);
                            }
                            if (decrementBtn) {
                                decrementBtn.setAttribute('disabled', 'true');
                                decrementBtn.classList.add(this.CLASSES.disabled);
                            }
                            let quantitySelectorContainer = document.querySelector(this.SELECTORS.quantitySelectorContainer);
                            if (quantitySelectorContainer) {
                                quantitySelectorContainer.classList.add('d-none');
                            }
                        }
                        if (inputQuantity) {
                            inputQuantity.value = deltaAvailableInventory;
                            inputQuantity.setAttribute('aria-label', deltaAvailableInventory);
                        }
                        if (incrementBtn) {
                            incrementBtn.setAttribute('disabled', 'true');
                            incrementBtn.classList.add(this.CLASSES.disabled);
                        }
                    }
                    if (inputQuantity) {
                        inputQuantity.setAttribute('data-maxqty', deltaAvailableInventory);
                    }
                    analyticsUtils.updateDataLayer(this._el, data);
                }
                this._el.classList.remove(this.CLASSES.loading);
                let page = document.querySelector('.page');
                this.updateMessageInModal('modal-feedback-success', message);
                let modalSuccess = document.querySelector('#modal-feedback-success');
                if (modalSuccess) {
                    const actionButtons = modalSuccess.querySelector('.modal-feedback-actions');
                    if (actionButtons && page && page.dataset.action === 'Cart-Show') {
                        actionButtons.classList.add('d-none');
                    }
                    else {
                        actionButtons.classList.remove('d-none');
                    }
                    micromodalInstance.forceShow('modal-feedback-success');
                }
                if (page && page.dataset.action === 'Cart-Show') {
                    customEventBus.emit('cartCookie:update', { pid: this._options.pid });
                    location.reload();
                }
            }
            customEventBus.emit('cartCookie:update', { pid: this._options.pid });
        }
        catch (error) {
            console.error(error);
            this._el.classList.remove(this.CLASSES.loading);
            this.updateMessageInModal('modal-feedback-error', this._el.dataset.labelError);
            micromodalInstance.forceShow('modal-feedback-error');
        }
    }
    async addToCart(pid, qty, excludedCustomerType) {
        this._el.classList.add(this.CLASSES.loading);
        let formData = new FormData();
        formData.append('pid', pid);
        formData.append('quantity', qty);
        if (excludedCustomerType) {
            formData.append('excludedCustomerType', excludedCustomerType);
        }
        return await fetch(this._options.endpointAddtocart, {
            method: 'POST',
            body: formData,
            headers: {
                'X-Requested-With': 'XMLHttpRequest',
            },
        })
            .then((response) => response.json())
            .catch((err) => {
            this._el.classList.remove(this.CLASSES.loading);
            this.updateMessageInModal('modal-feedback-error', this._el.dataset.labelError);
            micromodalInstance.forceShow('modal-feedback-error');
        });
    }
}
